export const defaultCutSpinnerValue = () => {
    return {
      box_styles: { 
        width: 200, height: 200 
      },
      arc1_styles:{
        bg_color:"#f00"
      },
      arc2_styles:{
        bg_color:"#fff"
      },
      circle_angle:0,
      spinner_angle:0,
      padding:10,
      stroke_width:2
    };
}